<app-header></app-header>

<div class="container mt-5 mb-5">
  <div class="container image-container text-center">
    <img src="/assets/expired.png" alt="" height="250" />
    <div class="text-center">
      <h1 style="color: #00943a"><strong>This link has expired</strong></h1>
      <!-- <p style="font-size: 16px; padding: 1srem 0px">
          Your password link is expired send another request to reset your password.
        </p> -->
      <button
        mat-stroked-button
        [style.width.%]="30"
        style="
          background-color: #00943a;
          color: #ffffff;
          font-size: 16px;
          height: 50px;
        "
        class="g-0 mt-3"
        type="button"
        (click)="navigateLogin()"
      >
        Go back and try again
      </button>

      <!-- <p class="mt-3 mb-3"><a href="/login"></a></p> -->
    </div>
  </div>
</div>

<app-footer></app-footer>
<p>expired-link works!</p>
